var $ = window.$;
function Exposure (targetDom, lastSecond, exposureParams, exposureEvent) {
    this.lastSecond = lastSecond;
    this.targetDom = targetDom;
    this.exposureParams = exposureParams;
    this.hoverTimer = null;
    this.exposureEvent = exposureEvent;
    this.exposureBind();
}
Exposure.prototype = {
    constructor: Exposure,
    exposureBind : function () {
        var that = this;

        $(that.targetDom).mouseenter(function () {
            clearTimeout(that.hoverTimer);
            that.hoverTimer = setTimeout(function () {
                if (typeof that.exposureEvent == 'function') {
                    that.exposureEvent(that.exposureParams);
                    that.hoverTimer = null;
                } else {
                    window.FCAdLog && window.FCAdLog.sendGIO(that.exposureParams.type, that.exposureParams)
                    that.hoverTimer = null;
                }
            }, that.lastSecond);
        });

        $(that.targetDom).mouseleave(function () {
            if (that.hoverTimer) {
                clearTimeout(that.hoverTimer);
                that.hoverTimer = null;
            }
        });
    }
}

module.exports = Exposure;


// WEBPACK FOOTER //
// ./src/assets/util/hover-exposure.js